if ( !customElements.get('daily-deal-card') ) {

  class DailyDealCard extends HTMLElement {

    connectedCallback(){
      this.endsAt = Number(this.dataset.endsAt);
      this.timeEl = this.querySelector('[data-daily-deal-time]');
      this.unitEls = {};
      this.querySelectorAll('[data-daily-deal-unit]').forEach(el => {
        this.unitEls[el.dataset.dailyDealUnit] = el;
      });
      this.daysEls = this.querySelectorAll('[data-daily-deal-days]');
      this._tick();
      if ( !this.hidden ) {
        this._interval = setInterval(this._tick.bind(this), 1000);
      }
    }

    disconnectedCallback(){
      clearInterval(this._interval);
    }

    _tick(){
      const remaining = this.endsAt - Date.now();
      if ( !(remaining > 0) ) {
        this._expire();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const parts = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor(totalSeconds % 86400 / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      };
      const pad = value => String(value).padStart(2, '0');

      Object.entries(this.unitEls).forEach(([unit, el]) => {
        el.textContent = pad(parts[unit]);
      });
      this.daysEls.forEach(el => {
        el.hidden = parts.days === 0;
      });

      if ( this.timeEl ) {
        const clock = `${pad(parts.hours)}:${pad(parts.minutes)}:${pad(parts.seconds)}`;
        this.timeEl.textContent = parts.days > 0 ? `${parts.days}${this.dataset.daysLabel} ${clock}` : clock;
      }
    }

    _expire(){
      clearInterval(this._interval);
      this.hidden = true;
      const fallback = this.parentElement.querySelector(':scope > [data-daily-deal-fallback]');
      if ( fallback ) {
        fallback.hidden = false;
      }
      this.parentElement.classList.remove('block-grid-item--deal-first');
    }

  }

  customElements.define('daily-deal-card', DailyDealCard);

}
